// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-block{display:block}.content-block.content-block--rounded .content-block__body{border-radius:4px}.content-block__head{color:#c6c6c6;margin-bottom:10px}.content-block__body{padding:15px;background-color:#fff}", ""]);
// Exports
module.exports = exports;
